import React, { Component } from "react";
import { withRouter } from "react-router";

import { NavLink } from "react-router-dom";
import { Title } from "../../utils/consts";

import SearchBox from "../SearchBox/SearchBox";

import "./nav.css";

class Nav extends Component {
  render() {
    return (
      <nav className="nav">
        <ul className="nav__list">
          {this.props.location && this.props.location.pathname !== "/" ? (
            <SearchBox />
          ) : (
            <NavLink
              activeClassName="nav__link_active"
              className="nav__link"
              to={"/"}
            >
              {Title}
            </NavLink>
          )}
        </ul>
      </nav>
    );
  }
}

export default withRouter(Nav);

// {
//   <NavLink
//     activeClassName="nav__link_active"
//     className="nav__link"
//     to={"/about"}
//   >
//   <li className="nav__list-item">About</li>
// </NavLink>
//   <NavLink
//     activeClassName="nav__link_active"
//     className="nav__link"
//     to={"/trends"}
//   >
//     <li className="nav__list-item">Trends</li>
//   </NavLink>}



// WEBPACK FOOTER //
// ./src/components/nav/Nav.js